"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CancelledIcon = void 0;
var React = require("react");
var IconWrapper_1 = require("../Icon/IconWrapper");
var CancelledIcon = function (props) { return (React.createElement(IconWrapper_1.IconWrapper, __assign({}, props),
    React.createElement("path", { fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd", d: "M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM6.99731 15.7466L15.7467 6.99715C16.0906 6.65329 16.6533 6.65331 16.9972 6.99717C17.341 7.34104 16.9972 8.24759 16.9972 8.24759L8.24773 16.997C8.24773 16.997 7.34118 17.3409 6.99731 16.997C6.65345 16.6531 6.65345 16.0904 6.99731 15.7466Z" }))); };
exports.CancelledIcon = CancelledIcon;
